var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.VUE_APP_SEATING)?_c('div',[_c('b-embed',{staticStyle:{"height":"1080px"},attrs:{"type":"iframe","aspect":"16by9","src":_vm.VUE_APP_SEATING,"allowfullscreen":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }